const CONSENT_KEY = "philCarrAdvertisingCookies";
const GOOGLE_ADS_ID = "AW-18467179773";
let configured = false;
export const GOOGLE_ADS_LEAD_SEND_TO = `${GOOGLE_ADS_ID}/d0uOCKiN7IAdEP2Z6-VE`;

export function hasAdsConsent(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(CONSENT_KEY) === "accepted";
  } catch {
    return false;
  }
}

export function adsConsentChoice(): "accepted" | "rejected" | null {
  if (typeof window === "undefined") return null;
  try {
    const choice = window.localStorage.getItem(CONSENT_KEY);
    return choice === "accepted" || choice === "rejected" ? choice : null;
  } catch {
    return null;
  }
}

export function saveAdsConsent(choice: "accepted" | "rejected") {
  try {
    window.localStorage.setItem(CONSENT_KEY, choice);
  } catch {
    // Storage can be unavailable. Do not enable advertising without saved consent.
  }
}

export function loadGoogleAdsTag() {
  if (typeof document === "undefined" || !hasAdsConsent() || configured) return;
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function (...args: unknown[]) {
      window.dataLayer?.push(args as unknown as Record<string, unknown>);
    };
    window.gtag("js", new Date());
  }
  window.gtag("config", GOOGLE_ADS_ID);
  configured = true;
  // A consented GA4 tag already loads gtag.js. Reuse it when present.
  if (document.getElementById("phil-carr-ga4-tag")) return;
  const script = document.createElement("script");
  script.id = "phil-carr-google-ads-tag";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  script.onerror = () => script.remove();
  document.head.appendChild(script);
}

export function revokeGoogleAdsTag() {
  if (typeof window === "undefined") return;
  window.gtag?.("consent", "update", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  for (const cookie of document.cookie.split(";")) {
    const name = cookie.split("=")[0]?.trim();
    if (name?.startsWith("_gcl_")) {
      document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
    }
  }
  // Loaded Google script cannot be unloaded. Reload with consent denied to stop further hits.
  if (configured) window.location.reload();
}
